import type { UserBase } from 'models';
import { Card, Form } from 'ui';
import { MemberCommunitiesList } from './member-communities-list';
import {
  MemberCommunitiesListFilters,
  type MemberCommunitiesListFiltersFormValues,
} from './member-communities-list-filters';

type FormValues = MemberCommunitiesListFiltersFormValues;

type P = { getPathToCommunityDetail: (id: string) => string; member: UserBase };

const MemberCommunities = ({ getPathToCommunityDetail, member }: P) => (
  <Card>
    <Form<FormValues> noOptional>
      <MemberCommunitiesListFilters />
      <Form.Item<FormValues> dependencies={['search']} noStyle>
        {({ getFieldsValue }) => {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
          const { search } = getFieldsValue(true) as FormValues;

          return (
            <MemberCommunitiesList
              getPathToCommunityDetail={getPathToCommunityDetail}
              memberId={member.id}
              search={search}
            />
          );
        }}
      </Form.Item>
    </Form>
  </Card>
);

export default MemberCommunities;
